import api from './api';

class BookingService {
    listBooking(dataForm) {
        return api.post('/merchant/booking',  dataForm);
    }

    cancelBooking(bookingCode) {
        return api.post('/merchant/booking/cancel/' + bookingCode);
    }

    calendarPing() {
        return api.post('/merchant/booking/calendar/ping');
    }

    calendarEvents(dataForm) {
        return api.post('/merchant/booking/calendar/events', dataForm);
    }

    // SH011 — the appointment overview: booking rows first, calendar-only events merged in.
    salonAppointments(dataForm) {
        return api.post('/merchant/booking/calendar/appointments', dataForm);
    }

    createCalendarEvent(dataForm) {
        return api.post('/merchant/booking/calendar/event', dataForm);
    }

    // SH035 — rewrites an existing appointment in place; the event id is what the booking
    // row and the POS bill hang off, so the edit must never become a delete plus a create.
    updateCalendarEvent(dataForm) {
        return api.post('/merchant/booking/calendar/event/update', dataForm);
    }

    deleteCalendarEvent(eventId) {
        return api.post('/merchant/booking/calendar/event/delete/' + eventId);
    }

    // SH038 — a stretch of one day a staff member is away: a full day off, a half day, or
    // any run of quarter hours the merchant drags out on the day view.
    createTimeOff(dataForm) {
        return api.post('/merchant/booking/calendar/time-off', dataForm);
    }

    deleteTimeOff(id) {
        return api.post('/merchant/booking/calendar/time-off/delete/' + id);
    }

    // SH038 — the sale channel's menu, so an appointment's service, price and duration all
    // come from the same place the customer's booking flow reads them from.
    salonServices(dataForm) {
        return api.post('/merchant/booking/calendar/services', dataForm);
    }

    salonServiceDetail(dataForm) {
        return api.post('/merchant/booking/calendar/service-detail', dataForm);
    }
}

export default new BookingService();